<template>
  <div>
    <Row :gutter="8">
      <Col span="4">
        <Input v-model="name" type="text" placeholder="物品名称" clearable @on-clear="searchChange" />
      </Col>
      <Col span="8">
        <Button type="primary" icon="ios-search" @click="search" style="margin-right:5px">查询</Button>
        <Button type="success" icon="md-add" @click="jump('integralGoodsItemAdd', {action:'add'})" style="margin-right:5px">新增</Button>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table border ref="table" size="small" :columns="columns" :data="tableData" :height="tableHeight"></Table>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="text-align:center">
        <Page :total="total" :page-size="pageSize" :current="pageNumber" show-elevator show-sizer show-total
          @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      </Col>
    </Row>
    <Modal v-model="modal" title="增加库存" width="500">
      <Form ref="detail" :model="detail" :rules="ruleValidate" :label-width="120">
        <FormItem label="增加数量" prop="addQuantity">
          <Input v-model="detail.addQuantity" type="text" placeholder="增加数量" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="saveAdd" style="width:80px">确定</Button>
        <Button type="default" @click="modal=false" style="width:80px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "integralGoodsItem",
  data() {
    const validateNum = (rule, value, callback) => {
      if (!value) { callback(new Error("请输入数量")); return; }
      if (!/^\d+$/.test(value)) { callback(new Error("请输入正整数")); return; }
      callback();
    };
    return {
      name: "", modal: false, addId: "",
      detail: { addQuantity: "" },
      columns: [
        { title: "序号", width: 80, align: "center", render: (h, p) => h("span", p.index + 1) },
        { title: "物品名称", key: "name", minWidth: 140, align: "center", tooltip: true },
        { title: "积分值", key: "integralBranch", minWidth: 80, align: "center" },
        { title: "总数量", key: "totalQuantity", minWidth: 80, align: "center" },
        { title: "在库数量", key: "warehouseQuantity", minWidth: 80, align: "center" },
        { title: "可兑换数量", key: "saleQuantity", minWidth: 90, align: "center" },
        {
          title: "操作", minWidth: 260, align: "center",
          render: (h, p) => h("div", [
            h("Button", { style: { margin: "0 5px" }, props: { type: "success", size: "small" }, on: { click: () => this.jump("integralGoodsItemAdd", { action: "edit", id: p.row.id }) } }, "修改"),
            h("Button", { style: { margin: "0 5px 0 0" }, props: { type: "info", size: "small" }, on: { click: () => { this.addId = p.row.id; this.modal = true; this.detail.addQuantity = ""; } } }, "增加库存"),
            h("Button", { style: { margin: "0 5px 0 0" }, props: { type: "error", size: "small" }, on: { click: () => this.deleteConfirm(p.row.id) } }, "删除"),
          ])
        },
      ],
      tableData: [], tableHeight: 500, total: 0, pageNumber: 1, pageSize: 10,
      ruleValidate: { addQuantity: [{ required: true, validator: validateNum }] },
    };
  },
  created() { this.getData(); },
  mounted() { this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220; },
  methods: {
    getData() {
      let msg = this.$Message.loading({ content: "正在获取数据", duration: 0 });
      this.$http.get("/api/tIntegralGoods/page", { params: { name: this.name, currentPage: this.pageNumber, pageSize: this.pageSize } }).then(r => { msg(); if (r.data.code == 200) { this.tableData = r.data.data.list; this.total = r.data.data.total; } }).catch(() => msg());
    },
    search() { this.pageNumber = 1; this.getData(); },
    pageChange(p) { this.pageNumber = p; this.getData(); },
    pageSizeChange(s) { this.pageSize = s; this.pageNumber = 1; this.getData(); },
    deleteConfirm(id) { this.$Modal.confirm({ title: "提示", content: "确认删除？", onOk: () => { this.$http.get("/api/tIntegralGoods/delete", { params: { id } }).then(r => { if (r.data.code == 200) { this.$Message.success("删除成功"); this.getData(); } }); } }); },
    saveAdd() {
      this.$refs.detail.validate(v => {
        if (!v) return;
        this.$http.post("/api/tIntegralGoods/addQuantity", { id: this.addId, addQuantity: Number(this.detail.addQuantity) }).then(() => { this.$Message.success("增加库存成功"); this.modal = false; this.getData(); this.$refs.detail.resetFields(); });
      });
    },
    searchChange() { this.getData(); },
  },
};
</script>
<style scoped>.ivu-row { margin-bottom: 10px; }</style>
